 /**
 * Setup: add the below script include to pages that have a checkout button
 * 
 * <script src="{{ 'skio-volume-discount.js' | asset_url }}" defer="defer"></script>
 * 
 * Make sure the selector below covers all checkout buttons
 */

// scope variables
document.addEventListener('DOMContentLoaded', function () {
  let rulesPromise;
  let applyPromise;

  function getRules() {
    if (!rulesPromise) {
      rulesPromise = fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${window?.Shopify?.shop}`)
        .then(response => {
          if (!response.ok) throw new Error(`Skio rules request failed: ${response.status}`);
          return response.json();
        })
        .then(data => Array.isArray(data.rules) ? data.rules : [])
        .catch(error => {
          rulesPromise = null;
          throw error;
        });
    }

    return rulesPromise;
  }

  async function applyVolumeDiscount () {
    const [rules, cartResponse] = await Promise.all([getRules(), fetch('/cart.js')]);
    if (!cartResponse.ok) throw new Error(`Cart request failed: ${cartResponse.status}`);

    const cart = await cartResponse.json();
  
    // Check each rule to find the eligible rule 
    // with the largest min quantity
    let largestMinQuantity = {
      value: -1,
      index: -1,
    }
    
    rules.forEach((rule, index) => {
      if (rule.code &&
          largestMinQuantity.value < rule.minQuantityToDiscount
      ) {
        // Gets the count of eligible items in the cart for this rule
        const eligibleCount = cart.items.reduce(
          (aggregate, item) => rule.productVariantIds.some(gid => gid.includes(item.id)) ? 
              aggregate + item.quantity : aggregate 
          , 0)
        if (rule.minQuantityToDiscount <= eligibleCount) {
          largestMinQuantity.value = rule.minQuantityToDiscount
          largestMinQuantity.index = index
        }
      }
    })
  
    const rule = largestMinQuantity.index > -1 ? rules[largestMinQuantity.index] : null

    // Apply code
    if (rule && rule.code !== window.localStorage.getItem('skio_applied_rule_code')) {
      const discountResponse = await fetch(`/discount/${rule.code}`);
      if (!discountResponse.ok) throw new Error(`Discount request failed: ${discountResponse.status}`);
      window.localStorage.setItem('skio_applied_rule_code', rule.code);
      return true;
    }

    return false;
  }

  function applyVolumeDiscountOnCartEvent() {
    if (!applyPromise) {
      applyPromise = applyVolumeDiscount()
        .then(stateChanged => {
          if (stateChanged && window.AMP_API?.OPEN_CART) window.AMP_API.OPEN_CART();
        })
        .catch(error => console.error('[Skio volume discounts]', error))
        .finally(() => {
          applyPromise = null;
        });
    }

    return applyPromise;
  }

  window.AMP_CART_UPDATED = applyVolumeDiscountOnCartEvent;
  window.AMP_CART_OPENED = applyVolumeDiscountOnCartEvent;

  // Preserve the discount check for direct visits to a non-empty cart while
  // keeping the requests off unrelated storefront routes.
  if (document.getElementById('CartPageForm')) {
    applyVolumeDiscountOnCartEvent();
  }

  // document.addEventListener('rebuy:cart.change', (event) => {
  //   applyVolumeDiscount();
  // });
  // document.addEventListener('rebuy:smartcart.show', (event) => {
  //   applyVolumeDiscount();
  // });
});
